import ReportViewer, {
  accountxReportUrl,
} from '@account-root/account-react/src/containers/DigitalReportModule/ReportViewer';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import { useHistory, useLocation } from 'react-router';
import { formatDashDate } from 'helpers/StringNumberFunction/FormatDate';
import React from 'react';

export const AmortisationScheduleReport = () => {
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem('loggedInUser'));
  const accountID = user.accountID;
  let location = useLocation();
  const editData = location?.state as any;

  const parameters = [
    { name: 'accountid', value: accountID },
    { name: 'companyid', value: editData?.CompanyID },
    { name: 'invoicecategory', value: editData?.InvoiceCategory },
    { name: 'debtoraccountid', value: editData?.DebtorAccountID },
    {
      name: 'amortstartdate',
      value: editData?.AmortStartDate
        ? formatDashDate(new Date(editData?.AmortStartDate).toISOString())
        : null,
    },
    {
      name: 'amortenddate',
      value: editData?.AmortEndDate
        ? formatDashDate(new Date(editData?.AmortEndDate).toISOString())
        : null,
    },
  ];

  const generatedurl = (reportName, parameters) => {
    let reporturl = reportName;

    parameters?.map((x, index) => {
      const symbol = index === 0 ? '?' : '&';
      if (x?.value !== undefined)
        reporturl = reporturl + symbol + x?.name + '=' + x?.value;
    });

    return reporturl;
  };

  return (
    <>
      <MainHeader
        onClick={() => history.push(`/digital-reports/account-receivable`)}
        mainBtn="close"
        smTitle="Account Receivable"
        title={user?.companyName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Submenu' },
          { name: 'Parameters' },
          { name: 'Amortisation Schedule Report', current: true },
        ]}
        rightRouteSegments={[{ name: 'Report', current: true }]}
      />
      <ContentWrapper style={{ maxHeight: '100%' }}>
        {ReportViewer({
          url: generatedurl('AmortisationScheduleReport', parameters),
          host: accountxReportUrl,
          excludedExportFormat: [],
        })}
      </ContentWrapper>
    </>
  );
};
